import { createAction } from '@reduxjs/toolkit';

export const register = createAction<{
  email: string;
  password: string;
  referralCode?: string;
}>('RegisterPage/REGISTER');
